export const confirmationDialogSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '92%', sm: 440 },
  maxHeight: '100vh',
  bgcolor: '#FFFFFF',
  border: 'none',
  boxShadow: '0px 24px 48px rgba(28, 27, 31, 0.18)',
  overflowY: 'auto',
  borderRadius: '28px',
  p: 3,
};

export const confirmationIconSx = {
  width: 72,
  height: 72,
  borderRadius: '50%',
  bgcolor: '#FDE1DC',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const confirmationTitleSx = {
  color: '#C40000',
  fontWeight: 700,
  fontSize: 24,
  lineHeight: '32px',
  letterSpacing: 0,
};

export const confirmationTextSx = {
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#49454F',
};

export const confirmationPrimaryButtonSx = {
  minWidth: 96,
  height: 40,
  px: 3,
  borderRadius: '999px',
  textTransform: 'none',
  bgcolor: '#4F8506',
  color: '#FFFFFF',
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  fontWeight: 500,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: '#4F8506',
    boxShadow: 'none',
  },
};

export const confirmationSecondaryButtonSx = {
  minWidth: 96,
  height: 40,
  px: 2,
  borderRadius: '999px',
  textTransform: 'none',
  color: '#DA342E',
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  fontWeight: 500,
};

export const buttonContentSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1,
  color: 'inherit',
};
